const normalizeLanguageKey = (value) => {
  if (value == null || value === "") {
    return "";
  }

  return value
    .toString()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
};

const getLanguageProficiencyLabel = (t, namespace, value) => {
  if (value == null || value === "") {
    return "";
  }

  const key = normalizeLanguageKey(value);
  if (!key) {
    return String(value);
  }

  return t(`${namespace}.${key}`, { defaultValue: value });
};

const getLanguageLabel = (t, value) =>
  getLanguageProficiencyLabel(t, "jobs.language_proficiency.languages", value);

const getProficiencyLabel = (t, value) => {
  if (value == null || value === "") {
    return "";
  }

  const keyMap = {
    Conversational: "conversational",
    Professional: "professional",
    Native: "native",
    "N/A": "na",
  };

  const key =
    keyMap[value] || normalizeLanguageKey(value) || String(value).toLowerCase();

  if (!key) {
    return String(value);
  }

  return t(`jobs.language_proficiency.levels.${key}`, { defaultValue: value });
};

export {
  getLanguageLabel,
  getProficiencyLabel,
  normalizeLanguageKey,
};
